export function distance(day) {
    //过去的时间戳
    var now = new Date(day * 1000);
    //过去
    //年
    var year = now.getFullYear();
    //月
    var month = now.getMonth() + 1;
    //日
    var date = now.getDate();
    var timer = year+'-'+ month+'-'+date

    return timer
}


// WEBPACK FOOTER //
// ./src/util/reset_time.js